module.exports = __webpack_public_path__ + "static/media/DSC09931.9e42dc46.jpg";